<template>
  <div class="width98 margin-auto backwhite">
    <!-- 内容· -->
    <div class="width98 margin-auto pad-top20 pad-bot20">
      <!-- 内容表单 -->
      <div class="f16 textalign-left dimensional">成果编辑</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="pad-top20 pad-bot10 Project-boder flex-betweenwrap"
      >
        <el-form-item label="" class="width48" prop="title">
          <p class="textalign-left">
            <span style="color: red">*</span> 成果名称
          </p>
          <el-input
            placeholder="请输入成果名称"
            v-model="form.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width48">
          <p class="textalign-left">成果估值(万元)</p>
          <el-input
            placeholder="请输入成果估值(万元)"
            v-model="form.amount"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="researchclass" class="width48">
          <p class="textalign-left">
            <span style="color: red">*</span> 量产或产业化状态
          </p>
          <el-select
            v-model="form.pro"
            placeholder="请选择量产或产业化状态"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in optionclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" class="width48">
          <p class="textalign-left">
            <span style="color: red">*</span> 成果技术分类
          </p>
          <el-input
            placeholder="请选择技术分类"
            v-model="form.ipc"
            class="width100"
            @focus="smallchange()"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="researchclass" class="width48">
          <p class="textalign-left">
            <span style="color: red">*</span> 成果适用行业
          </p>
          <el-select
            v-model="form.industry_id"
            placeholder="请选择成果适用行业"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in industry"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成果封面" class="width98">
          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccesshead"
            :on-error="handleerrorhead"
            :data="userhead"
            :headers="head"
            style="margin-top: 40px"
          >
            <img v-if="pictureurl" :src="pictureurl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p class="textalign-left">技术成熟度说明</p>
          <wangEditor
            v-model="form.maturity"
            :isClear="isClear"
            class="textalign-left"
          ></wangEditor>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p class="textalign-left">成果详细说明</p>
          <wangEditor
            v-model="form.remark"
            :isClear="isClear"
            class="textalign-left"
          ></wangEditor>
        </el-form-item>
      </el-form>
      <div class="but-box textalign-right">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button type="primary" class="cursorpointer" @click="Savechanges()">
          保 存
        </el-button>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="ipcdilog"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f18">项目分类</p>
      <div class="margin-top20 dialogitem">
        <el-tree
          class="isdisabled"
          :data="ipcdata"
          accordion
          :props="defaultProps"
          @node-click="handleNodeClick"
          :check-on-click-node="true"
          :check-strictly="true"
          :show-checkbox="checkbox"
          @check="treeCheck"
          @node-expand="nodeExpand"
          node-key="title"
          ref="treeForm"
          :highlight-current="true"
        ></el-tree>
      </div>
      <p class="textalign-right margin-top20">
        <el-button type="primary" @click="ipctitle()">确 定</el-button>
        <el-button @click="ipcdilog = false">关 闭</el-button>
      </p>
    </el-dialog>
  </div>
</template>
    
    <script>
import {
  patentleveldata,
  entachievementsdetail,
  entachievementsupdate,
} from "@/api/Center/Center.api";
import { entproductgoodindustry } from "@/api/business/business.api";
import wangEditor from "@/components/wangEditor";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      ipcdilog: false,
      form: {
        title: "",
        amount: "",
        pro: "",
        remark: "",
        ipc: "",
        industry_id: "",
        maturity: "",
      },
      num: 200,
      str: "",
      id: "",
      rules: {
        title: [
          { required: true, message: "请输入成果名称：", trigger: "blur" },
        ],
        researchclass: [
          {
            required: true,
            message: "请选择量产或产业化状态",
            trigger: "blur",
          },
        ],
      },
      optionclass: [
        {
          value: "0",
          label: "未量产或未实现产业化",
        },
        {
          value: "1",
          label: "已产量或已实现产业化",
        },
      ],
      Apisrc: "",
      picture: "",
      pictureurl: "",
      userhead: {
        images: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      picturehead: "",
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      ipcdata: [],

      defaultProps: {
        children: "sub",
        label: "detail",
      },
      checkbox: false,
      industry: [],
    };
  },

  methods: {
    handleNodeClick(data, e, node) {
      data.sub = [{}];

      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },
    treeCheck: function (node, list) {
      //node 该节点所对应的对象、list 树目前的选中状态对象
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点

      this.form.ipc = node.title;
      if (list.checkedKeys.length == 2) {
        //单选实现
        this.$refs.treeForm.setCheckedKeys([node.title]);
      }
    },
    ipctitle() {
      this.ipcdilog = false;
    },
    nodeExpand(data, e, node) {
      data.sub = [{}];
      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },
    smallchange() {
      this.ipcdilog = true;
    },
    // 上传附件
    handleAvatarSuccesshead(response, res, file) {
      this.picture = res.name;
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        if (response.data.url.indexOf("http") == -1) {
          this.pictureurl = this.picturehead + response.data.url;
        } else {
          this.pictureurl = response.data.url;
        }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerrorhead(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    beforeupload(file) {
      this.gattachmentuser.filename = file.name;
    },
    monitorInput() {
      var txtVal = this.remark.length;
      this.num = 200 - txtVal;
    },

    Savechanges() {
      if (this.form.pro == "已量产或已实现产业化") {
        this.form.pro = 1;
      } else if (this.form.pro == "未量产或未实现产业化") {
        this.form.pro = 0;
      }

      entachievementsupdate({
        title: this.form.title, //成果名称
        image: this.pictureurl, //成果封面图
        ipc: this.form.ipc, //ipc技术分类
        industry_id: this.form.industry_id, //行业ID
        amount: this.form.amount, //成果自估值
        maturity: this.form.maturity, //技术成熟度说明
        pro: this.form.pro, //是否产业化
        remark: this.form.remark, //成果详细说明
        id: this.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
          });
          setTimeout(() => {
            BUS.$emit("Achievementnum", this.id);
            window.sessionStorage.setItem("Achievementnum", this.id);
            window.sessionStorage.setItem("AchievementNamefujian", "first");
            this.$router.push({
              path: "/Results-trading/Results-muchadd",
            });
          }, 2000);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      this.$router.push({
        path: "/Results-trading/Results-management",
      });
    },
  },
  components: { wangEditor },
  created() {
    this.projectName = window.sessionStorage.getItem("name");
    this.Apisrc = window.g.ApiUrl + "/oss_form";
    this.picturehead = window.g.Apisrc;
    patentleveldata({ pid: 0 }).then((res) => {
      if (res.data.code == 200) {
        this.ipcdata = res.data.data;
        res.data.data.forEach((i) => {
          i.disabled = true;
          this.checkbox = false;
          i.sub = [{}];
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 行业
    entproductgoodindustry({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.industry = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    this.id = window.sessionStorage.getItem("Achievementnum");

    //    获取详情
    entachievementsdetail({ id: this.id }).then((res) => {
      if (res.data.code == 200) {
        this.form.title = res.data.data.title;
        if (res.data.data.pro == 0) {
          this.form.pro = "未量产或未实现产业化";
        } else {
          this.form.pro = "已量产或已实现产业化";
        }

        this.form.amount = res.data.data.amount;
        this.form.remark = res.data.data.remark;
        this.form.ipc = res.data.data.ipc;
        this.form.industry_id = res.data.data.industry_id;
        this.form.maturity = res.data.data.maturity;
        // this.pictureurl = res.data.data.image;
        if (res.data.data.image.indexOf("http") == -1) {
          this.pictureurl = this.picturehead + res.data.data.image;
        } else {
          this.pictureurl = res.data.data.image;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
    
<style scoped>
.dialogitem {
  overflow-y: scroll;
  height: 500px;
}
.isdisabled >>> .is-disabled {
  display: none !important;
}
.isdisabled >>> .el-tree-node__content {
  display: flex;
  align-items: baseline;
  white-space: wrap;
  height: 100%;
  outline: 0;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}
.dimensional {
  padding: 3px 0 3px 10px;
  border-left: 4px solid #52c5cb;
}
/* 表单盒子 */
.but-box {
  width: 100%;
  margin: auto;
}
::placeholder {
  color: #a4a4a4;
  font-size: 12px;
}
.avatar-uploader {
  text-align: left;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  border: 1px dashed #e5e5e5;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
    